import React from 'react';
import { Gamepad2, Twitter, Instagram, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy text-brand-offwhite border-t-8 border-brand-pink" data-id="element-40">
      <div className="container mx-auto px-4 py-16" data-id="element-41">
        <div className="grid md:grid-cols-4 gap-12" data-id="element-42">
          <div className="col-span-1 md:col-span-2" data-id="element-43">
            <div className="flex items-center gap-2 mb-6" data-id="element-44">
              <Gamepad2 className="w-8 h-8 text-brand-lime" data-id="element-45" />
              <span className="text-2xl font-display font-bold" data-id="element-46">
                Jeuxtraordinaire
              </span>
            </div>
            <p className="text-gray-400 max-w-sm font-body mb-6" data-id="element-47">
              The world's premier destination for games that defy explanation.
              If it's normal, we don't want it.
            </p>
            <div className="flex gap-4" data-id="element-48">
              {[Twitter, Instagram, Github].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 bg-brand-offwhite text-brand-navy flex items-center justify-center rounded-none hover:bg-brand-lime hover:-translate-y-1 transition-all duration-200" data-id="element-49">
                  <Icon size={20} data-id="element-50" />
                </a>)}
            </div>
          </div>

          <div data-id="element-51">
            <h4 className="font-display font-bold text-xl mb-6 text-brand-pink" data-id="element-52">
              Explore
            </h4>
            <ul className="space-y-3 font-body text-gray-300" data-id="element-53">
              <li data-id="element-54">
                <a href="#" className="hover:text-brand-lime hover:underline decoration-wavy" data-id="element-55">
                  Curated Collections
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="hover:text-brand-lime hover:underline decoration-wavy" data-id="element-57">
                  The Manifesto
                </a>
              </li>
              <li data-id="element-58">
                <a href="#" className="hover:text-brand-lime hover:underline decoration-wavy" data-id="element-59">
                  Submit a Game
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-brand-lime hover:underline decoration-wavy" data-id="element-61">
                  Gift Cards
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-62">
            <h4 className="font-display font-bold text-xl mb-6 text-brand-yellow" data-id="element-63">
              Visit Us
            </h4>
            <address className="not-italic font-body text-gray-300 space-y-2" data-id="element-64">
              <p data-id="element-65">123 Quirky Lane</p>
              <p data-id="element-66">Limassol, Cyprus</p>
              <p className="text-sm text-gray-500 mt-4" data-id="element-67">
                (No phone. We communicate only via carrier pigeon or email.)
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500 font-mono" data-id="element-68">
          <p data-id="element-69">© 2026 Jeuxtraordinaire. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-70">
            <a href="#" className="hover:text-white" data-id="element-71">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-72">
              Terms of Weirdness
            </a>
          </div>
        </div>
      </div>
    </footer>;
}